<template>
  <a-modal
    class="cash-modal-wrapper"
    width="702px"
    :body-style="{paddingLeft:'130px'}"
    :mask-closable="false"
    :visible="visible"
    :title="title"
    :confirm-loading="btnIsLoading"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <a-row>
      <a-col :span="24">
        <span class="label-text">姓名</span>{{ data.true_name }}
      </a-col>
      <a-col :span="24">
        <span class="label-text">开户行</span>{{ data.bank_deposit }}
      </a-col>
      <a-col :span="24">
        <span class="label-text">银行卡号</span>{{ data.card_number }}
      </a-col>
      <a-col :span="24">
        <span class="label-text">提现金额</span>{{ data.cash_money }}
      </a-col>
      <a-col :span="24">
        <span class="label-text">申请时间</span>{{ data.create_time }}
      </a-col>
    </a-row>
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #status>
        <a-radio-group
          v-decorator="['status',{rules: [
            { required: true},
          ],initialValue:1}]"
          @change="e=>$emit('changeRadio',e)"
        >
          <a-radio :value="1">
            通过
          </a-radio>
          <a-radio :value="2">
            不通过
          </a-radio>
        </a-radio-group>
      </template>
      <template #reason>
        <a-textarea
          v-decorator="['reason',{rules: [
            { required: true,message:'请说明原因'},
          ],}]"
          :row="2"
          placeholder="请说明原因"
        />
      </template>
      <template #img_id>
        <a-upload
          v-decorator="[
            'img_id',
            {
              rules: [{ required: true, message: '请上传图片' }] ,
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          accept=".jpg,.png,.jpeg"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :data="{fileType:'img',}"
          :action="`${uploadUrl}fileup/up`"
          :before-upload="beforeUpload"
        >
          <img
            v-if="$refs.basicForm && $refs.basicForm.form.getFieldValue('img_id') && $refs.basicForm.form.getFieldValue('img_id').length === 1 && $refs.basicForm.form.getFieldValue('img_id')[0].status === 'done'"
            width="100"
            height="100"
            :src="$refs.basicForm.form.getFieldValue('img_id')[0].url"
            alt="avatar"
          >
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
      </template>
    </basic-form>
  </a-modal>
</template>
<script>

export default{
  props: ['title', 'visible', 'btnIsLoading', 'disabled', 'data', 'formData'],
  data(){
    return{
      loading: false,
    };
  },
  mounted(){

  },
  methods: {
    normFile(e) {
      if (e && e.file.status === 'uploading') {
        this.loading = true;
      }
      if(e && e.file.status === 'done'){
        const fileList = [{
          uid: e.file.response.data.id,
          status: 'done',
          name: 'img',
          url: e.file.response.data.url,
        }];
        this.loading = false;
        return fileList;
      }
      return e.fileList;
    },
    // 上传前
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('图片小于10M！');
      }
      return isLt2M;
    },
  },
};
</script>
<style lang="scss" scoped>
.cash-modal-wrapper{
.ant-col-24{
  margin-bottom: 18px;
  .label-text{
  color: rgba(0, 0, 0, 0.85);
  margin-right:20px;
  width:70px;
  display: inline-block;
}
}
}


</style>